import { entityToModelBase } from 'shared/domain/toBaseModel';
import { LevelModel } from 'shared/domain/level/types/model';
import { UserEntity } from 'shared/domain/user/types/entity';
import { LevelInDto } from 'shared/dtos/in/level';
import { LevelEntity } from 'shared/domain/level/types/entity';

export function levelInDtoToEntity(level: LevelInDto): LevelEntity {
  return {
    _id: level._id,
    createdAt: level.createdAt,
    createdBy: level.createdBy,
    deleted: level.deleted ? 1 : 0,
    index: level.index,
    label: level.label,
    map: level.map,
    modifiedAt: level.modifiedAt,
    modifiedBy: level.modifiedBy,
    site: level.site,
  };
}

export function levelEntityToModel(
  entity: LevelEntity,
  users: UserEntity[]
): LevelModel {
  const modelBase = entityToModelBase({
    entity,
    users,
  });
  return {
    ...modelBase,
    index: entity.index,
    label: entity.label,
    map: entity.map,
    site: entity.site,
  };
}
